import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageH1 from "@components/seo/PageH1";
const LegalBodyContent = ({ title, bodyContent }) => {
    return (_jsxs("section", { className: "legal-wrapper-body-content", children: [title && (_jsx(PageH1, { fallbackElement: "h2", className: "legal-wrapper-body-content-title", children: title })), _jsx("div", { className: "legal-wrapper-body-content-description", dangerouslySetInnerHTML: { __html: bodyContent } })] }));
};
export default LegalBodyContent;
